import { useState } from 'react'

const useBoolean = (defaultVal = false) => {
    const [val, setVal] = useState(defaultVal)

    const updateValue = {
        toggle: () => setVal((oldVal) => !oldVal),
        on: () => setVal(true),
        off: () => setVal(false),
    }

    return [val, updateValue]
}

export default useBoolean
